/**
 * 158 — the server's refusals about codes, in a form the screens can name: the
 * item's ordinal (the client adds its chunk offset → the Excel row) and the
 * code. And a 23505 on either code constraint: 054's primary-vs-primary or
 * 158's registry (an extra on two products).
 */
export type CodeRefusal = { kind: 'conflict' | 'plu' | 'too_many' | 'invalid' | 'taken' | 'not_found'; ordinal: number; code: string | null }

const KINDS: [RegExp, CodeRefusal['kind'], boolean][] = [
  [/^CODE_TAKEN:(\d+):([\s\S]*)$/, 'taken', true],
  [/^BARCODE_CONFLICT:(\d+):([\s\S]*)$/, 'conflict', true],
  [/^PLU_CONFLICT:(\d+)$/, 'plu', false],
  [/^TOO_MANY_BARCODES:(\d+)$/, 'too_many', false],
  [/^BARCODE_INVALID:(\d+)$/, 'invalid', false],
  [/^PRODUCT_NOT_FOUND:(\d+)$/, 'not_found', false],
]

export function parseCodeRefusal(message: string | null | undefined): CodeRefusal | null {
  const m0 = String(message ?? '').trim()
  for (const [re, kind, withCode] of KINDS) {
    const m = re.exec(m0)
    if (m) return { kind, ordinal: Number(m[1]), code: withCode ? m[2] : null }
  }
  return null
}

export function isDuplicateCode(error: unknown): boolean {
  const e = error as { code?: string; message?: string } | null
  if (!e || e.code !== '23505') return false
  const m = String(e.message ?? '')
  return m.includes('uq_products_barcode') || m.includes('uq_product_codes')
}

/** The code a 23505 names: „Key (org_id, btrim(barcode))=(org, CODE)" or „Key (org_id, code)=(org, CODE)". */
export function duplicateCodeOf(error: unknown): string | null {
  const d = String((error as { details?: string } | null)?.details ?? '')
  return /\)=\([^,]+,\s*(.+)\)\s+already exists/.exec(d)?.[1]?.trim() ?? null
}
